import {OptimizeProgress} from "./optimize-progress";

export class OptimizeProgressMapper {

  public static map(data: any): OptimizeProgress {
    const OptimizeProgressData: OptimizeProgress = new OptimizeProgress();
    OptimizeProgressData.status = data.status; // "active"|"success"|"fail"

    OptimizeProgressData.progressPercent = Math.round(data.progress);
    OptimizeProgressData.complete = ['success', 'fail', 'done'].indexOf(data.status) !== -1;
    OptimizeProgressData.message = data.message || "";

    return OptimizeProgressData;
  }

}
